import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./app";
import { BrowserRouter } from "react-router-dom";
import "./index.scss";
import { Loader } from "@widgets/Loader";
import { useLoadApp } from "@shared/utils";

const AppLoader = () => {
  const { isLoaded, isAppReady } = useLoadApp();

  return (
    <>
      {(!isLoaded || !isAppReady) && <Loader />}
      {isLoaded && (
        <BrowserRouter>
          <App />
        </BrowserRouter>
      )}
    </>
  );
};

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <AppLoader />
  </React.StrictMode>
);
